import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil, Nillable } from '@web/utils';
import { AccountTypeProviderService } from '../providers/account-type-provider.service';
import { AccountType } from '../enums/account-type';

@Pipe({
  name: 'accountTypeLabel',
  standalone: true,
})
export class AccountTypeLabelPipe implements PipeTransform {
  private readonly provider = inject(AccountTypeProviderService);

  public transform(type: Nillable<AccountType>): Observable<Nillable<string>> {
    if (isNil(type)) {
      return of(type);
    }

    return this.provider.label(type);
  }
}
